import MatchPlayLeaderboard from './match-play-leaderboard'
import MatchPlayLeaderboardQuery from './match-play-leaderboard.query'

export { MatchPlayLeaderboardQuery }
export default MatchPlayLeaderboard
